import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBvsbmWOtzvmATfgY3rZY8PcwQvLcagROY",
  authDomain: "rgbcontroller-940f3.firebaseapp.com",
  projectId: "rgbcontroller-940f3",
  storageBucket: "rgbcontroller-940f3.firebasestorage.app",
  messagingSenderId: "623299539534",
  appId: "1:623299539534:web:3740ef041b77382dc5891f",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
